import { API_GET_QNA_UPDATE_TICKET } from 'config/data';
import { AppState } from 'interface/stateApp';
import { Colaborator } from 'model/response';
import React, { useEffect, useState } from 'react';
import { getColaborators } from 'service/userService';
import { MEDIA_TYPE, ROLE_NAME } from 'utils/data';
import { fetchApiPut } from 'utils/helper';
import toast, { NotifyType } from 'utils/toast';

interface FormProps {
  stateApp: AppState;
  setStateApp: React.Dispatch<React.SetStateAction<AppState>>;
  ticket?: any;
  onData?: any;
}

const CollaboratorsList = ({ stateApp, setStateApp, ticket, onData }: FormProps) => {
  const [colaborators, setColaborators] = useState<Colaborator[]>([]);

  useEffect(() => {
    getColaborators(ticket?.typeColaborator)
      .then((response) => {
        setColaborators(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [ticket]);

  const updateTicket = async (colaboratorId: any) => {
    const data = { ...ticket, colaboratorId: colaboratorId };
    const response = await fetchApiPut(`${API_GET_QNA_UPDATE_TICKET}${ticket?.id}`, data, MEDIA_TYPE.JSON);
    if (response !== null) {
      if (onData) {
        onData(data);
      }
    } else {
      toast(NotifyType.ERROR, 'Có lỗi xảy ra!');
    }
    setStateApp({ ...stateApp, showColaboratorListForm: false });
  };

  return (
    <div className="container mx-auto p-4 overflow-y-auto max-h-[450px]">
      <h2 className="text-center text-[17px] mb-3">Danh sách công tác viên môn </h2>
      {colaborators.map((collaborator) => (
        <div className="flex items-center p-4 bg-white shadow-md rounded-lg mb-4 ">
          <img src={collaborator?.imageUrl} alt={collaborator?.fullName} className="w-16 h-16 rounded-full mr-4" />
          <div className="flex-1">
            <h2 className="text-[15px] text-[#3498db] font-medium">{collaborator?.fullName}</h2>
          </div>
          <div className="flex-1">
            <h2 className="text-[15px] text-[#616161]">
              {collaborator?.role === ROLE_NAME.ROLE_CTV ? 'Công tác viên' : 'Chuyên gia'}
            </h2>
          </div>
          <button
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            onClick={() => updateTicket(collaborator?.id)}
          >
            Giao
          </button>
        </div>
      ))}
    </div>
  );
};

export default CollaboratorsList;
